export const SUM = 'SUM';
export const AVG = 'AVG';
export const MIN = 'MIN';
export const MAX = 'MAX';
export const COUNT = 'COUNT';
export const PERCENTILES = 'PERCENTILES';
export const DISTINCT_APPROX = 'DISTINCT_APPROX';
// For fetching logic, median is just the 50th percentile
// This is mapped to MEDIAN to correctly map to/visualize the data
export const MEDIAN = 'MEDIAN';